import React from 'react';

const DashboardBackdrop = (props) => (
    <div className="dashboardbackdrop" onClick={props.click}/>
);

export default DashboardBackdrop;